// ContactCard.jsx
import React from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import '../styles/ContactCard.css';

function ContactCard({ name, title, email, phone, imageSrc, address }) {
  return (
    <div className="contact-card">
      <div className="avatar-container">
        <img src={imageSrc} alt={`${name}'s photo`} className="avatar" />
      </div>
      <div className="contact-info">
        <h2>{name}</h2>
        {title && <p className="title">{title}</p>}
        <div className="contact-detail">
          <FaEnvelope className="icon" />
          <a href={`mailto:${email}`}>{email}</a>
        </div>
        {phone && (
          <div className="contact-detail">
            <FaPhone className="icon" />
            <a href={`tel:${phone}`}>{phone}</a>
          </div>
        )}
        {address && (
          <div className="contact-detail">
            <FaMapMarkerAlt className="icon" />
            <span>{address}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default ContactCard;